import { Check, ChevronRight } from 'lucide-react';
import type { UserProfile } from '~/types';
import { Button } from '~/components/ui/button';
import { Avatar, AvatarFallback } from '~/components/ui/avatar';

interface Props {
  isLoading: boolean;
  userProfiles: UserProfile[];
  selectedUserProfiles: UserProfile[];
  onUserProfileSelect: (userProfile: UserProfile) => void;
}

export function SelectFromExistingProfiles({
  isLoading,
  userProfiles,
  selectedUserProfiles,
  onUserProfileSelect,
}: Props) {
  return (
    <div className="flex flex-col gap-2">
      {userProfiles.map((userProfile) => {
        const isSelected = selectedUserProfiles.includes(userProfile);

        return (
          <Button
            key={userProfile.id}
            className="h-16 w-full items-center justify-between"
            variant={isSelected ? undefined : 'outline'}
            onClick={() => onUserProfileSelect(userProfile)}
            disabled={isLoading}
          >
            <div className="flex items-center gap-7">
              <Avatar>
                <AvatarFallback variant={isSelected ? 'selected' : undefined}>
                  {userProfile.firstName.charAt(0)}
                  {userProfile.lastName.charAt(0)}
                </AvatarFallback>
              </Avatar>
              <span className="text-lg">
                {userProfile.firstName} {userProfile.lastName}
              </span>
            </div>
            <div className="flex items-center justify-center gap-1 text-sm font-medium">
              {isSelected ? (
                <Check size={16} />
              ) : (
                <>
                  <span>Register</span>
                  <ChevronRight size={16} />
                </>
              )}
            </div>
          </Button>
        );
      })}
    </div>
  );
}
